import { render, staticRenderFns } from "./tians.vue?vue&type=template&id=1ea80588&scoped=true&"
import script from "./tians.vue?vue&type=script&lang=js&"
export * from "./tians.vue?vue&type=script&lang=js&"
import style0 from "./tians.vue?vue&type=style&index=0&id=1ea80588&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea80588",
  null
  
)

export default component.exports